// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__3Abrd","actionsCol":"EnrolledClinics_actionsCol__ROjDH"};